"use client";
import React, { useEffect } from "react";
import { Card } from "antd";
import { cn } from "../../utils/cn";
import { FiFilter, FiPlus } from "react-icons/fi";
import { Dropdown, Button } from "antd";
import ListGridButtons from "./listGridViewButtons";
import CommonInput from "./input";
import { SearchOutlined } from "@ant-design/icons";
import CommonSelect from "./select";

const ExtraCmp = ({
  isAdvanceSearch,
  isSearch,
  isFilters,
  isListGridView,
  isCreateButton,
}) => {
  return (
    <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full sm:w-auto">
      {isAdvanceSearch?.show && (
        <Dropdown
          popupRender={() => (
            <div className="px-3  min-w-[300px] sm:-mr-5 mr-16 !bg-transparent">
              {isAdvanceSearch.children}
            </div>
          )}
          trigger={["click"]}
          placement="bottomRight"
          className="!bg-transparent"
        >
          <Button
            className={cn(
              "flex items-center justify-center gap-x-1 !bg-primary text-primary hover:!text-white hover:!bg-primary/80 !border hover:!border-primary w-full md:w-auto",
              isCreateButton.show &&
              "!bg-transparent !border !border-primary !text-primary hover:!bg-primary hover:!text-white transition-colors duration-150 ease-in-out"
            )}

            size="large"
            style={{ borderColor: "#2dbdf2" }}
          >
            <span>
              {" "}
              <FiFilter size={16} />
            </span>
            Advance Search
          </Button>
        </Dropdown>
      )}


      {isCreateButton.show && (
        <Button
          className="flex items-center justify-center gap-x-1 !bg-primary text-white hover:!bg-primary/80 hover:!border-primary w-full md:w-auto"
          size="large"
          onClick={isCreateButton.onclick}
        >
          <span>
            <FiPlus size={16} />
          </span>
          {isCreateButton.text}
        </Button>
      )}
      {isListGridView.show && (
        <ListGridButtons
          viewType={isListGridView.viewType}
          setViewType={isListGridView.setViewType}
          viewFor={isListGridView.viewFor}
          className="sm:block hidden"
        />
      )}
    </div>
  );
};

const CommonCard = ({
  title,
  titleClassName,
  extra,
  children,
  style,
  className,
  cardHeaderClassName,
  isAdvanceSearch = {
    show: false,
    children: null,
  },
  isSearch = {
    show: false,
    searchInput: "",
    placeholder: "",
    setSearchInput: () => { },
  },
  isFilters = {
    show: false,
    data: null,
  },
  isListGridView = {
    show: false,
    viewType: "",
    setViewType: () => { },
    viewFor: "",
  },
  isLoading = {
    show: false,
    loaderCmp: null,
  },
  isCreateButton = {
    show: false,
    text: "",
    onclick: () => { },
  },
  isExtraButton = {
    show: false,
    title: "",
    className: "",
    onClick: () => { },
    icon: null,
    disabled: false,
    data: [] // New data array for multiple buttons
  },

  cardHeadBodyClassName = {
    header: "",
    body: ""
  },
}) => {


  // const shouldHideTitle =
  //   !title &&
  //   !isSearch?.show &&
  //   !isExtraButton?.show &&
  //   !isAdvanceSearch?.isClearButton?.show &&
  //   !isFilters?.show;


  const shouldHideExtra =
    !isAdvanceSearch?.show &&
    !isSearch?.show &&
    !isFilters?.show &&
    !isListGridView?.show &&
    !isCreateButton?.show &&
    !isExtraButton?.show;


  return (
    <Card
      {...(!shouldHideExtra && {
        title: (
          <div className={cn("flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 w-full sm:!py-3 py-4 md:py-0", cardHeaderClassName, (!isAdvanceSearch.show && !isCreateButton.show) ? "gap-0" : "", (isFilters.show || isExtraButton?.show) ? "mr-2" : "")}>
            {(isSearch?.show || isListGridView?.show) && (
              <div className="flex gap-x-1 w-full">
                {isSearch?.show && <CommonInput
                  placeholder={isSearch.placeholder || ""}
                  icon={<SearchOutlined />}
                  value={isSearch.searchInput}
                  onChange={(e) => isSearch.setSearchInput(e.target.value)}
                  className="w-full sm:!w-72"
                />}
                {isListGridView?.show && <div className="sm:hidden block">
                  <ListGridButtons
                    viewType={isListGridView.viewType}
                    setViewType={isListGridView.setViewType}
                    viewFor={isListGridView.viewFor}
                  />
                </div>}
              </div>
            )}

            <div className="flex flex-col sm:flex-row sm:items-center justify-between sm:gap-y-0 gap-x-2 items-start flex-1 w-full">
              <span className={cn("text-2xl font-semibold", titleClassName)}>{title}</span>

              {/* Right Side Actions Group */}
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full sm:w-auto sm:ml-auto">
                {(isFilters?.show || isExtraButton?.show) && <div className="flex flex-col sm:flex-row justify-end items-stretch sm:items-center gap-2 w-full sm:w-auto">
                  {isFilters?.show && (
                    <>
                      {
                        isFilters?.data?.map((filter) => (
                          <CommonSelect
                            key={filter.name}
                            placeholder={filter.placeholder}
                            options={filter.options}
                            onChange={filter.onChange}
                            className={filter.className}
                          />
                        ))
                      }
                    </>
                  )}
                  {isExtraButton?.show && (
                    <>
                      {isExtraButton?.data && isExtraButton.data.length > 0 ? (
                        isExtraButton.data.map((btn, index) => (
                          <Button
                            key={index}
                            type="link"
                            disabled={btn?.disabled}
                            onClick={btn.onClick}
                            className={cn(btn?.className, btn?.icon && "flex items-center gap-x-1")}
                          >
                            {btn?.icon && <span>{btn?.icon}</span>}
                            {btn?.title || ""}
                          </Button>
                        ))
                      ) : (
                        <Button
                          type="link"
                          disabled={isExtraButton?.disabled}
                          onClick={isExtraButton.onClick}
                          className={cn(isExtraButton?.className, isExtraButton?.icon && "flex items-center gap-x-1")}
                        >
                          {isExtraButton?.icon && <span>{isExtraButton?.icon}</span>}
                          {isExtraButton?.title || ""}
                        </Button>
                      )}
                    </>
                  )}
                </div>}

                {/* Advance Search Actions */}
                {!shouldHideExtra && (
                  <ExtraCmp
                    isAdvanceSearch={isAdvanceSearch}
                    isSearch={isSearch}
                    isFilters={isFilters}
                    isListGridView={isListGridView}
                    isCreateButton={isCreateButton}
                  />
                )}

                {isAdvanceSearch?.isClearButton?.show && (
                  <Button
                    type="link"
                    onClick={isAdvanceSearch?.isClearButton?.onClick}
                    className="md:ml-2"
                  >
                    {isAdvanceSearch?.isClearButton?.title}
                  </Button>
                )}
              </div>
            </div>
          </div>
        ),
      })}

      className={cn("!p-0", className)}
      classNames={{
        header: cn("sm:!px-6 px-2", cardHeadBodyClassName?.header),
        body: cn("sm:!px-6 px-2", cardHeadBodyClassName?.body)
      }}
      style={style}
    >
      <div>{isLoading.show ? isLoading.loaderCmp : children}</div>
    </Card>

  );
};

export default CommonCard;
